import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  apiURL :string = environment.apiEndPoint;
  sec :string = environment.secEndPoint;
  appName :string = environment.appName;
  private baseUrl = this.apiURL+'/lb4_store_script';
  private headers = {
    'Content-Type': 'application/json',
    realmname: '',
    Authorization: ''
  };
  constructor(private http: HttpClient) { }

  getHeaders(): any {
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      return {
        'Content-Type': 'application/json',
        'realmname': token?.realmname || '',
        'Authorization': 'Bearer '+token?.access_token || ''
      };
    } catch (error) {
      return {}
    }
  }

  // getting script tag
  getItems(data:any): Observable<any>{
    let inputData = {
      "shop_domain":data.shopifyDomain,
      "app_name":data.appName || this.appName
    }
    return this.http.post(this.baseUrl+'/getStoreScriptGql', inputData, { headers: this.getHeaders() });
  }

  refreshToken(): Observable<any>{
    return this.http.post(this.sec+'/AuthToken/refreshToken', {},{ withCredentials: true });
  }

  getAccessToken(inputData:{secret_data,secret_key,iv,given_role}): Observable<any>{
    return this.http.post(this.sec+'/AuthToken/getEmployeeAuthToken', inputData,{withCredentials: true });
  }

  logout(): Observable<any>{
    return this.http.get(this.sec+'/AuthToken/logout',{ withCredentials: true });
  }

  // CREATE new script tag
  createItem(data:any): Observable<any> {
    let inputData = {
      "shop_domain":data.shopifyDomain,
      "app_name":data.appName || this.appName,
      "src":data.scriptTagUrl
    }
    return this.http.post(this.baseUrl+'/createStoreScriptGql', inputData,{ headers:this.getHeaders() });
  }

  // UPDATE an existing script tag
  updateItem(data:any): Observable<any> {
    let inputData = {
      "shop_domain":data.shopifyDomain,
      "app_name":data.appName || this.appName,
      "tagId":data.scriptTagID,
      "src":data.scriptTagUrl
    }
    return this.http.post(this.baseUrl+'/updateStoreScriptGql', inputData,{ headers: this.getHeaders() });
  }

  // DELETE script tag
  deleteItem(data:any): Observable<any> {
    let inputData = {
      "shop_domain":data.shopifyDomain,
      "app_name":data.appName || this.appName,
      "tagId":data.scriptTagID
    }
    return this.http.post(this.baseUrl+'/deleteStoreScriptGql', inputData,{ headers: this.getHeaders() });
  }

  switchTagRequest(data:any): Observable<any> {
    let inputData = {
      "shop_domain":data.shopifyDomain,
      "app_name":data.appName || this.appName,
      "tagId":data.id,
      "src":data.src
    }
    return this.http.post(`${this.baseUrl}/switchScriptTagToProd`, inputData, { headers: this.getHeaders() });
  }

  getComponentHistory(domain: string): Observable<any> {
    let inputData = { domain };
    return this.http.post(`${this.baseUrl}/getComponentHistory`, inputData, { headers: this.getHeaders() });
  }
}

